import { render, staticRenderFns } from "./Autosuggest.vue?vue&type=template&id=5f1c12d3"
import script from "./Autosuggest.vue?vue&type=script&lang=js"
export * from "./Autosuggest.vue?vue&type=script&lang=js"
import style0 from "./Autosuggest.vue?vue&type=style&index=0&id=5f1c12d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports